export default "__VITE_ASSET__CGZyLR78__"